import { render, staticRenderFns } from "./Buddies_Rating.vue?vue&type=template&id=ede4b7cc&scoped=true"
import script from "./Buddies_Rating.vue?vue&type=script&lang=js"
export * from "./Buddies_Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede4b7cc",
  null
  
)

export default component.exports